// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"0d953b18","277":"4ad33c35","453":"46dc3e92","506":"75b9fd19","553":"b5149fda","647":"cfee4652","914":"60cd9224","977":"2e3d5464"}[chunkId] + ".chunk.js";
};